import React from "react";
import { motion } from "framer-motion";

const Cta = () => {

  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  return (
    <section className="cta-section">

      <motion.div
        className="container"
        initial={{ opacity: 0, scale: 0.98 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >

        {/* HEADING */}
        <motion.h2
          className="section-heading"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          Looking for a Reliable Bentonite Supplier?
        </motion.h2>

        {/* TEXT */}
        <motion.p
          className="section-text"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.7 }}
          viewport={{ once: true }}
        >
          Partner with <b className="bold">Iris Impulse India Pvt. Ltd.</b> for consistent quality, global expertise, and a reliable supply of high-performance bentonite solutions tailored to your industry needs. Backed by decades of experience, advanced processing capabilities, and a strong commitment to sustainability, we ensure dependable products and seamless service that support your operations and long-term growth.
        </motion.p>

        {/* BUTTON */}
        <motion.a
        href="/contact-us"
          className="black-btn"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.6 }}
          viewport={{ once: true }}
          whileHover={{ scale: 1.06 }}
          whileTap={{ scale: 0.97 }}
        >
          GET IN TOUCH
        </motion.a>

      </motion.div>

    </section>
  );
};

export default Cta;